import { useState } from "react";
import { faqs } from "@/mocks/faqs";

export default function FaqAccordion() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <div className="divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
      {faqs.map((f, i) => {
        const isOpen = openIndex === i;
        return (
          <div key={i}>
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? -1 : i)}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
              aria-expanded={isOpen}
            >
              <span className="flex items-start gap-3 text-sm font-medium text-foreground-900 md:text-base">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xs font-bold text-primary-700">
                  Q
                </span>
                {f.q}
              </span>
              <span
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-transform duration-300 ${
                  isOpen ? "rotate-180" : ""
                }`}
              >
                <i className="ri-arrow-down-s-line text-lg" />
              </span>
            </button>
            <div
              className={`grid transition-all duration-300 ${
                isOpen ? "grid-rows-[1fr] pb-4" : "grid-rows-[0fr]"
              }`}
            >
              <div className="overflow-hidden px-5">
                <div className="flex gap-3 border-l-2 border-primary-200 pl-3 text-sm leading-relaxed text-foreground-600">
                  {f.a}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}